// import { FuseUtils } from '@fuse/utils';

export class User
{
	// user.name = data.data().name;
    //     user.second_name = data.data().second_name;
    //     user.phone = data.data().phone;
    //     user.country = data.data().country;
    id: string;
    name: string;
    second_name: string;
    phone: string;
    country: string;
    photoUrl: string;
    /**
     * Constructor
     *
     * @param user
     */
    constructor(user)
    {
        {
            this.id = user.id || 0;
            this.name = user.name || '';
            this.second_name = user.second_name || '';
            this.phone = user.phone || '';
            this.country = user.country || '';
            this.photoUrl = user.photoUrl || '';
        }
    }
}
